import { useState, useEffect } from 'react';
import Trad from "../Utils/Constant"
import { useConfig, getConfigValue } from '../Utils/config';
import BackendConnector from '../Utils/BackendConnector';
import ProjectCard from './ProjectCard';

const AboutSection = () => {
    const { config, loading } = useConfig();
    const aboutText = getConfigValue(config, "HOME_ABOUT_TEXT");

    // Projets personnels : table projects côté backend. L'API ne renvoie que
    // les projets visibles, déjà triés par le champ order.
    const [projects, setProjects] = useState([]);

    useEffect(() => {
        BackendConnector.fetchData('projects/')
            .then(data => setProjects(Array.isArray(data) ? data : []))
            .catch(() => setProjects([]));
    }, []);

    const displayText = loading
        ? "Chargement..."
        : aboutText || Trad.DEFAULT_ABOUT_TEXT;
    
    return (
        <section id="about" className="section">
            <h2>{Trad.ABOUT_ME}</h2>
            
            <div className="about-profile-section">
                <div className="about-profile-image">
                    <img src={getConfigValue(config, "PROFIL_PICTURE") || Trad.PROFIL_PICTURE} alt={Trad.NAME} />
                </div>
                <div className="about-profession">
                    <h3>{Trad.TITLE}</h3>
                    <p className="about-intro-text">{displayText}</p>
                </div>
            </div>
            
            <div className="skills-section">
                <h3>{Trad.SKILLS_TITLE}</h3>
                <div className="skills-grid">
                    {Trad.SKILLS.map((skill, index) => (
                        <div key={index} className="skill-item">
                            <div className="skill-header">
                                <span className="skill-name">{skill.name}</span>
                                <span className="skill-percentage">{skill.percentage}%</span>
                            </div>
                            <div className="skill-frameworks">{skill.frameworks}</div>
                            <div className="skill-progress">
                                <div 
                                    className="skill-progress-bar" 
                                    style={{width: `${skill.percentage}%`}}
                                ></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {projects.length > 0 && (
                <div className="projects-section">
                    <h3>{Trad.PROJECTS_TITLE}</h3>
                    {projects.map(project => (
                        <ProjectCard key={project.id} project={project} />
                    ))}
                </div>
            )}
        </section>
    );
}

export default AboutSection;